import React from 'react';
import { Grid } from '@mui/material';
import { Code, PlayArrow, EmojiEvents, TrendingUp } from '@mui/icons-material';
import StatCard from '../../StatCard';

/**
 * StudentStatsSection - 学生 Dashboard 的统计卡片部分
 */
function StudentStatsSection({ totalQuestions, totalAttempted, totalCompleted, completionRate }) {
  return (
    <Grid container spacing={2} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={6} md={6} lg={3}>
        <StatCard
          title="总题目数"
          value={String(totalQuestions)}
          interval="题库题目总数"
          icon={Code}
          color="#667eea"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={3}>
        <StatCard
          title="已尝试"
          value={String(totalAttempted)}
          interval="已尝试题目数"
          icon={PlayArrow}
          color="#f093fb"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={3}>
        <StatCard
          title="已完成"
          value={String(totalCompleted)}
          interval="已通过题目数"
          icon={EmojiEvents}
          color="#4facfe"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={3}>
        <StatCard
          title="完成率"
          value={`${completionRate}%`}
          interval="完成率百分比"
          icon={TrendingUp}
          color="#fa709a"
        />
      </Grid>
    </Grid>
  );
}

export default StudentStatsSection;
